// Remotes
export interface Remote {
  url: string;
  scope: string;
}

export interface RemoteTool extends Remote {
  modules: {
    toolModule: string;
  };
}

export interface RemoteProjectList extends Remote {
  modules: {
    projectListModule: string;
    projectTemplatesModule: string;
    providersModule: string;
    projectsHeaderLinksModule: string;
    productLinksModule: string;
  };
}

export type Remotes = [RemoteProjectList, ...RemoteTool[]];

// Routes
export const LAYOUTS = {
  PROJECT_PAGE_LAYOUT: 'projectPageLayout',
  PUBLIC_PAGE_LAYOUT: 'publicPageLayout',
  PROJECT_DIRECTORY_LAYOUT: 'projectDirectoryLayout',
} as const;

type Layouts = typeof LAYOUTS;
export type LayoutType = Layouts[keyof Layouts];

interface RouteBase {
  path: string;
  scope: string;
}

export interface ToolRoute extends RouteBase {
  toolId: string;
  titleKey: string;
  productId: string;
  layout: Layouts['PROJECT_PAGE_LAYOUT'];
}

export interface ProjectsRoute extends RouteBase {
  moduleKey: keyof RemoteProjectList['modules'] | keyof RemoteTool['modules'];
  layout: Layouts['PROJECT_DIRECTORY_LAYOUT'];
}

export interface PublicRoute extends RouteBase {
  moduleKey: keyof RemoteTool['modules'];
  layout: Layouts['PUBLIC_PAGE_LAYOUT'];
}

export type Route = ToolRoute | ProjectsRoute | PublicRoute;
